import {campaignFormActions} from "../../../store/actions/campaignFormAction";
import {connect} from "react-redux";
import {useForm} from "react-hook-form";
import React, {useEffect} from "react";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import TimeOfDayMultiSelect from "./TimeOfDayMultiSelect";
import {timeOfDay as timeOfDayList} from "../../utils/DataList";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton, useTheme} from "@mui/material";
import useCustomStyles from "../../utils/UseCustomStyles";

const customStyles = (theme) => ({
    root: {
        marginTop: theme.spacing(1),
        padding: "12px 10px",
        backgroundColor: theme.palette.background.darkBlue,
        borderRadius: 4
    },
    title: {
        paddingTop: 4,
        fontSize: 14,
        fontWeight: 600
    },
    radio: {
        '&$checked': {
            color: theme.palette.error.light
        }
    },
    checked: {},
    deleteButton: {
        color: theme.palette.error.dark
    },
    addConditionButton: {
        textTransform: "none",
        padding: "2px 8px"
    }
});

function TimeOfDay(props) {
    const theme = useTheme();
    const classes = useCustomStyles(customStyles, theme);
    const {campaignFormState: {flow, selectedRuleNumber, selectedRule}} = props;

    const {control, setValue, getValues, reset} = useForm({
        defaultValues: {
            timeOfDayCondition: "is",
            timeOfDayValues: []
        }
    });

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    useEffect(() => {
        let condition = flow?.rules[selectedRuleNumber]?.conditions?.timeOfDay?.condition;
        if (condition === undefined || condition === "") {
            reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRule, selectedRuleNumber, selectedRule?.conditions?.timeOfDay?.condition]);

    useEffect(() => {
        let timeOfDay = flow?.rules[selectedRuleNumber]?.conditions?.timeOfDay;
        if (selectedRule !== null && timeOfDay?.condition !== "") {
            setValue("timeOfDayCondition", timeOfDay?.condition);

            let list = [];
            if (timeOfDay?.values !== null) {
                timeOfDay?.values?.forEach((item) => {
                    timeOfDayList?.forEach((i) => {
                        if (item === i?.code) {
                            list.push(i);
                        }
                    });
                });
                setValue("timeOfDayValues", list);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRuleNumber, selectedRule, flow.rules]);

    const updateCondition = () => {
        let list = [];
        getValues("timeOfDayValues")?.forEach((item) => {
            list.push(item.code);
        });

        props.updateCondition(
            props.campaignFormState.selectedRuleNumber,
            "timeOfDay",
            getValues("timeOfDayCondition"),
            false,
            list
        );
    };

    const removeCondition = () => {
        props.updateCondition(props.campaignFormState.selectedRuleNumber, "timeOfDay", "", false, null);
    };

    const addCondition = () => {
        props.updateCondition(props.campaignFormState.selectedRuleNumber, "timeOfDay", "is", false, []);
    };

    const renderAddCondition = () => {
        let condition = selectedRule?.conditions?.timeOfDay?.condition;
        if (condition === "" || condition === undefined) {
            return (
                <Box display="flex" flexDirection="row">
                    <Box flexGrow={1} className={classes?.title}>Time of day</Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            className={classes?.addConditionButton}
                            onClick={addCondition}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        let condition = selectedRule?.conditions?.timeOfDay?.condition;
        if (condition !== "" && condition !== undefined) {
            return (
                <>
                    <Box mb={1} display="flex" flexDirection="row">
                        <Box flexGrow={1} className={classes?.title}>Time of day</Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size={"small"}
                                className={classes?.deleteButton}
                                onClick={removeCondition}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            defaultValue="is"
                            control={control}
                            options={radioConditions}
                            name="timeOfDayCondition"
                            label="conditions"
                            updateOnChange={updateCondition}
                        />
                    </Box>
                    <Box>
                        <TimeOfDayMultiSelect
                            control={control}
                            updateOnChange={updateCondition}
                            inputName="timeOfDayValues"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <Box display="flex" flexDirection="column" className={classes?.root}>
            {renderAddCondition()}
            {renderConditionBox()}
        </Box>
    );
}

const mapStateToProps = (state) => ({
    campaignFormState: state.campaignForm,
});

const mapDispatchToProps = {
    updateCondition: campaignFormActions.updateCondition,
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeOfDay);